import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  /* position: absolute; */
  z-index: 1;
  border: 1px solid ${(p) => p.theme.palette.grey[300]};
  border-radius: ${(p) => p.theme.spacing(0.5)};
  overflow: hidden;
  background: ${(p) => p.theme.palette.common.white};
  list-style-type: none;
  margin-bottom: 0;
  margin-top: 0;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${(p) => p.theme.spacing(1)};
  width: 100%;
`;
